/**
 * Created by mateo on 5/26/17.
 */
import {
  Component, Input, OnInit, Output, EventEmitter, ElementRef,
  IterableDiffers, DoCheck
} from '@angular/core';

import {Item} from './item';

@Component({
  selector: 'custom-select',
  standalone: false,
  templateUrl: './customselect.component.html',
  styleUrls: ['./customselect.component.scss'],
  host: {
    '(document:click)': 'offClick($event)',
  }
})

export class CustomSelectComponent implements DoCheck, OnInit {
  //<editor-fold desc="declaración de variables">
  /**
   * Declaración de las entradas
   * */
  @Input() idFld: string = 'id';
  @Input() txtFld: string = 'text';
  @Input() public childrenField: string = 'children';
  @Input() public multiple: boolean = true;
  @Input() public parentWChildsList: boolean = true;
  @Input() selectedOptions: any = [];
  @Input() selectAll: boolean;
  @Input() selectAllVis: boolean = true;
  @Input() reset: boolean = false;
  @Input() lblClass: string = "";
  @Input() showTextFilter: boolean = true;
  @Input() showTags: boolean = true;


  selectAllStatus: boolean = false;

  @Input()
  options: any[];


  @Input()
  public set cslabel(texto: string) {
    if (texto.length == 0 || typeof texto == 'undefined') {
      this.placeholder = texto;
    } else {
      this.placeholder = texto;
    }
  }

  /**
   * TEST "NGMODEL"
   */
  selDataValue: any;


  @Input()
  get selData() {
    return this.selDataValue;
  }

  set selData(selData) {
    this.selDataValue = selData;
    this.itemObjs.map((el) => {
      if (this.selDataValue.indexOf(el.id) > -1) {
        el.selected = true;
        this.onItemClicked({item: el, selected: true})
      }
      if (el.hasOwnProperty('childs') && el.childs.length > 0) {
        el.childs.map((ch) => {
          if (this.selDataValue.indexOf(ch.id) > -1) {
            ch.selected = true;
            this.onItemClicked({item: ch, selected: true})
          }
        });
        if (el.childs.filter((e) => e.selected).length == el.childs.length) {
          el.selected = true;
        }
      }
    });
    this.selDataChange.emit(this.selDataValue);
  }

  @Input()
  public isTitle: boolean = false;

  @Output() selDataChange = new EventEmitter();

  //</editor-fold>

  updateSelData(selItem, accion) {
    let that = this;
    if (accion == 'add') {
      if (selItem.isParent()) {
        if (selItem.childs) {
          /*'Parent con hijos'*/
          selItem.childs.map((ch) => {
            if (that.selDataValue.indexOf(ch.id) < 0) {
              that.selDataValue.push(ch.id)
            }
          });
        } else {
          /*'Parent sin hijos'*/
          if (that.selDataValue.indexOf(selItem.id) < 0) {
            this.selDataValue.push(selItem.id);
          }
        }
      } else {
        if (that.selDataValue.indexOf(selItem.id) < 0) {
          this.selDataValue.push(selItem.id);
        }
      }
    } else if (accion == 'rem') {
      let iRem = -1;
      if (selItem.isParent()) {
        if (selItem.childs) {
          /*'Parent con hijos'*/
          selItem.childs.map((ch) => {
            iRem = that.selDataValue.indexOf(ch.id);
            if (iRem > -1) {
              that.selDataValue.splice(iRem, 1);
            }
          });
        } else {
          /*'Parent sin hijos'*/
          iRem = that.selDataValue.indexOf(selItem.id);
          if (iRem > -1) {
            that.selDataValue.splice(iRem, 1);
          }
        }
      } else {
        iRem = that.selDataValue.indexOf(selItem.id);
        if (iRem > -1) {
          that.selDataValue.splice(iRem, 1);
        }
      }
    }
  }

  /**
   * TEST "NGMODEL"
   */

  /**
   * Declaración de las salidas
   * */
  @Output() public refreshedData: EventEmitter<any> = new EventEmitter();
  @Output() public data: EventEmitter<any> = new EventEmitter();
  @Output() public selectedData: EventEmitter<any> = new EventEmitter();
  @Output() public deselectedData: EventEmitter<any> = new EventEmitter();
  @Output() public allSelected: EventEmitter<any> = new EventEmitter();

  /**
   * Declaración de variables privadas.
   * */
  private _items: Array<any> = [];

  /**
   * Declaración de variables públicas
   * */
  public itemObjs: Array<Item> = []; //Todos los elementos existentes de tipo <Item>
  public opciones: Array<Item> = []; //Opciones que se desplegarán en el custom-select.
  public seleccionadas: Array<Item> = [];
  public placeholder: string;

  //Elementos de control
  public showSeleccionadas: boolean = false;
  public showOpciones: boolean = false;
  public showChildList: boolean = false;

  //New features


  /**
   * Método para capturar la emisión del evento clic sobre el Item.
   *
   * @param {any} value - Contiene los parámetros enviados por el evento emisor.
   */
  private onItemClicked(value: any) {
    if (value.item.id === 'all') {
      this.selectAllItems(value.selected);
    } else {
      if (value.item.childs) {
        value.item.childs.map((child: Item) => {
          child.selected = value.selected
        })
      }
      if (value.selected) {
        this.agregarItemSeleccionado(value.item);
      } else {
        this.removerItemSeleccionado(value.item);
      }
    }
  }

  /**
   * Método para marcar o desmarcar todas las opciones
   * @param {boolean} selected
   */
  private selectAllItems(selected: boolean) {
    let that = this;
    this.itemObjs.map((el) => {
      el.selected = selected;
      that.onItemClicked({item: el, selected: selected});
    });
  }

  /**
   * Método para agregar elemento Item a los seleccionados.
   *
   * @param selItem
   */
  private agregarItemSeleccionado(selItem: Item) {
    if (!this.multiple) {
      this.seleccionadas = [new Item(selItem)];
    } else if (this.parentWChildsList) {
      if (selItem.isParent()) {
        let parent = this.seleccionadas.filter((value) => {
            return value.id == selItem.id
          }),
          index = this.seleccionadas.indexOf(parent[0]);
        if (index > -1) {
          /*CASO: Ya existe el padre*/
          let newParent = new Item({id: selItem.id, label: selItem.label, childs: selItem.childs});
          this.seleccionadas[index].childs = newParent.childs;
        } else {
          /*CASO: No existe el padre')*/
          let newParent = new Item(selItem);
          this.seleccionadas.push(newParent);
        }
      } else {
        //Si no es parent se verifica si el parent ya está en las seleccionadas bajo el parent.
        let parent = this.seleccionadas.filter((value) => {
            return value.id == selItem.parent.id
          }),
          index = this.seleccionadas.indexOf(parent[0]);
        if (index > -1) {
          let newItem = new Item({id: selItem.id, label: selItem.label, selected: true});
          this.seleccionadas[index].childs.push(newItem);
        } else {
          let newParent = new Item({
              id: selItem.parent.id,
              label: selItem.parent.label,
              selected: true,
              childs: []
            }),
            newItem = new Item({id: selItem.id, label: selItem.label, selected: true});
          newParent.childs.push(newItem);
          this.seleccionadas.push(newParent);
        }
      }
      this.updateSelData(selItem, 'add');
    }

    this.refreshedData.emit(this.seleccionadas);
    this.selectedData.emit(selItem);
    this.emitSelectedData();
  }

  private removerItemSeleccionado(selItem: Item) {
    if (this.parentWChildsList) {
      if (selItem.isParent()) {
        let parent = this.seleccionadas.filter((value) => {
            return value.id == selItem.id
          }),
          index = this.seleccionadas.indexOf(parent[0]);
        if (index > -1) {
          this.seleccionadas.splice(index, 1);
        }
      } else {
        let parent = this.seleccionadas.filter((value) => {
            return value.id == selItem.parent.id;
          }),
          index = this.seleccionadas.indexOf(parent[0]);
        if (index > -1) {
          let child = this.seleccionadas[index].childs.filter((value) => {
              return value.id == selItem.id;
            }),
            childIndex = this.seleccionadas[index].childs.indexOf(child[0]);
          if (childIndex > -1) {
            this.seleccionadas[index].childs.splice(childIndex, 1);
          }
          if (this.seleccionadas[index].childs.length === 0) {
            this.seleccionadas.splice(index, 1);
          }
        }
      }
      this.updateSelData(selItem, 'rem');
    }

    this.refreshedData.emit(this.seleccionadas);
    this.deselectedData.emit(selItem);
    this.emitSelectedData();
  }

  /**
   * Captura el evento click y lo emite.
   *
   * @param {Item} value - Item asociado a la opción seleccionada.
   * @param {object} evt - El evento que desencadeno el método en el elemento asociado.
   */
  clicked(value: Item, evt) {
    let clickObj = {event: {target: evt.target}, selected: evt.target.checked, item: value};
    value.selected = evt.target.checked;
    this.onItemClicked(clickObj);
  }

  /**
   * Método usado por el botón eliminar en el elemento de lista.
   *
   * @param item
   */
  public removerListItem(item: Item, event) {
    event.stopPropagation();
    let remObj = this.itemObjs.filter((value) => {
      return value.id == item.id;
    });
    remObj[0].selected = false;
    if (remObj[0].childs) {
      remObj[0].childs.map((it) => {
        it.selected = false;
      });
    }
    this.removerItemSeleccionado(item);
  }

  private emitSelectedData() {
    let data = this.seleccionadas.map((it) => {
      if (it.childs) {
        return it.childs.map((ch) => {
          return ch.id.toString();
        }).toString();
      } else {
        return it.id.toString();
      }
    });

    let rawData = data.toString().split(',');
    //Se verifica si el valor de retorno es una cadena sin valores. Si es así se asigna un arreglo vacío como retorno
    if (rawData && rawData.length == 1 && rawData[0] == "") {
      rawData = [];
    }

    this.data.emit(rawData);
  }

  private updatePlaceholder(data: string[]) {
    if (data.length > 0 && data[0] != "") {
      this.placeholder = data.length + ' elementos seleccionados';
    } else {
      this.placeholder = 'Seleccione algunas opciones';
    }
  }

  /**
   * Método para controlar la visibilidad de los elementos del select.
   *
   * @param {boolean} val - El valor emitido desde el control.
   * @param {string} tipo - El tipo de visibilidad.
   */
  setVisibility(val: boolean, tipo: string): void {
    let that = this;
    if (tipo === 'opciones') {
      //Se controlan todos los elementos.
      this.showOpciones = !val;
      this.showSeleccionadas = !val;
      setTimeout(function () {
        if (!val && that.showTextFilter) {
          that._eref.nativeElement.querySelector('.cs-search-text').focus(); //TODO
        }
      }, 150);
    }
    if (tipo === 'lista') {
      //se controla solo la lista de seleccionados
      this.showSeleccionadas = !val;
    }
  }

  itD;

  public constructor(private _eref: ElementRef, private _itDiff: IterableDiffers) {
    this.selDataValue = [];
    this.itD = this._itDiff.find([]).create(null);
  }

  private offClick(event) {
    let e = event.target;
    if (!this._eref.nativeElement.contains(e) && !(e.className.indexOf('cs-') > -1)) {
      this.showSeleccionadas = false;
      this.showOpciones = false;
    }
  }


  private doTextFilter(evt) {
    let filterVal = evt.target.value.toLowerCase();

    this.itemObjs.map((elem) => {
      if ('childs' in elem && elem.childs.length > 0) {
        elem.childs.map((ch) => {
          if (ch.label.toLowerCase().indexOf(filterVal) > -1) {
            ch.visible = true;
          } else {
            ch.visible = false;
          }
        });
        if (elem.childs.filter(ch => ch.visible).length > 0) {
          elem.visible = true;
        } else {
          elem.visible = false
        }
      } else {
        //En caso de lista sin hijos.
        if (elem.label.toLowerCase().indexOf(filterVal) > -1) {
          elem.visible = true;
        } else {
          elem.visible = false;
        }
      }
    });
  }

  private resetSelect() {
    this.itemObjs.map((item) => {
      item.selected = false;
      if (item.childs) {
        item.childs.map((child) => {
          child.selected = false;
        })
      }
    });
    this.seleccionadas = [];
    this.emitSelectedData();
  }

  ngOnInit() {
    let opts = this.options;
    if (!opts) {
      this._items = [];
    } else {
      this.itemObjs = opts.map((item: any) => (typeof item === 'string' ? new Item(item) : new Item({
        id: item['id'],
        label: item['label'],
        childs: item['childs']
      })));
    }
    /**
     * Script para iniciar los valores seleccionados.
     */
    this.itemObjs.map((item) => {
      if (item.childs && item.childs.length > 0) {
        item.childs.map((child) => {
          if (this.selectedOptions.indexOf(child.id.toString()) > -1) {
            child.selected = true;
            this.agregarItemSeleccionado(child);
          }
        });
      }
      if (this.selectedOptions.indexOf(item.id.toString()) > -1 && !item.childs) {
        item.selected = true;
        this.agregarItemSeleccionado(item);
      }
    });
    if (this.itemObjs.length == this.selectedOptions.length) {
      this.selectAllStatus = true;
    }

    this.emitSelectedData();
  }

  ngDoCheck() {
    let optsChanges = this.itD.diff(this.options);
    if (optsChanges) {
      optsChanges.forEachAddedItem((el) => {
        if (this.itemObjs.filter(itemEl => {
          return el.item.id == itemEl.id
        }).length == 0) {
          this.itemObjs.push(new Item(el.item));
        }
      });
      optsChanges.forEachRemovedItem((el) => {
        let currIt = this.itemObjs.filter(itemEl => {
            return itemEl.id == el.item.id
          }),
          ind = this.itemObjs.indexOf(currIt[0]);
        if (ind > -1) {
          this.itemObjs.splice(ind, 1);
        }
      });
    }
  }
}
